import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CreditCard, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="bg-[#0369A1] py-24 px-4 text-center relative overflow-hidden" data-id="element-117">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-5 pointer-events-none" data-id="element-118">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full border-[40px] border-[#F97316]" data-id="element-119"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        scale: 0.5
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-6xl mb-6" data-id="element-121">
          🏑
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-5xl md:text-7xl font-bold text-[#F97316] mb-6 uppercase tracking-wide" data-id="element-122">
          HOCKEY 360
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-2xl md:text-3xl text-white font-medium mb-12" data-id="element-123">
          El sistema de planificación N°1 para entrenadores de hockey
          argentinos.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-124">
          <a href="#precio" className="inline-block bg-[#F97316] hover:bg-[#EA580C] text-white font-bold text-2xl md:text-3xl px-10 py-6 rounded-xl shadow-[0_0_40px_rgba(249,115,22,0.4)] transition-all hover:scale-105 active:scale-95 uppercase tracking-wide mb-10 w-full md:w-auto" data-id="element-125">
            🏑 QUIERO MI HOCKEY 360 AHORA
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="flex flex-wrap justify-center items-center gap-4 md:gap-6 text-white/80 mb-12 font-medium" data-id="element-126">
          <div className="flex items-center gap-2" data-id="element-127">
            <ShieldCheck className="w-5 h-5 text-[#F97316]" data-id="element-128" />
            <span data-id="element-129">Garantía 7 días</span>
          </div>
          <span className="hidden md:inline text-white/30" data-id="element-130">|</span>
          <div className="flex items-center gap-2" data-id="element-131">
            <Lock className="w-5 h-5 text-[#F97316]" data-id="element-132" />
            <span data-id="element-133">Pago seguro</span>
          </div>
          <span className="hidden md:inline text-white/30" data-id="element-134">|</span>
          <div className="flex items-center gap-2" data-id="element-135">
            <Zap className="w-5 h-5 text-[#F97316]" data-id="element-136" />
            <span data-id="element-137">Acceso en 5 minutos</span>
          </div>
          <span className="hidden md:inline text-white/30" data-id="element-138">|</span>
          <div className="flex items-center gap-2" data-id="element-139">
            <CreditCard className="w-5 h-5 text-[#F97316]" data-id="element-140" />
            <span data-id="element-141">Tarjetas y transferencia</span>
          </div>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="text-xl md:text-2xl text-white/90 italic" data-id="element-142">
          "Porque preparar una buena práctica no debería costarte todas las
          noches de la semana."
        </motion.p>
      </div>
    </section>;
}